import { DataSourceVector, ProviderTypes, Shape } from "../core/global";
import { ColourScale } from '../helpers/colours';

export interface LayerDescription {
  hide?: boolean
  title: string
  // name?: LayerTypes | null
  attribution?: string
  url?: string | string[]
  colours?: ColourScale | null
  reverse?: boolean
  valueKey?: string
  minValueKey?: string
  maxValueKey?: string
  dataUrl?: string    // used for scale
  minValue?: number   // pre-loaded min value - used for scale
  maxValue?: number   /// pre-loaded max value
  displayMaxValue?: number // max display value for scale for non-linear scaling
  units?: string
  shortName?: string
  show_bands?: boolean
  minValueLabel?: string
  maxValueLabel?: string
  format?: string         // this is a value formatting string
}

export interface LayerShape {
  [key: string]: {
    data: LayerDescription[],
  }
}

export interface ModelShapeItem {
  key: string,
  name: string,
  layers: LayerDescription[],
  vectors: DataSourceVector
  description: string,
  model: string,
  provider: string,
  geography: string,
  source: string
  tokens_cost_per_year: number,
  start_date: string,
  end_date: string,
  resolution: string,
  frequency: number,
  vertical_reference: string,
  temporal_reference: string,
  vector_tiles: string | null,
  has_averages: boolean,
  version: string | null,
  bounds: string | null
  max_lat: number | null
  max_lon: number | null 
  min_lat: number | null
  min_lon: number | null
  options: Shape[] | null
  regular?: boolean
  grid_resolution?: [number, number] | null
}

export interface ModelShape {
  [key: string]: ModelShapeItem
}

export interface ProviderShapeItem {
  title: string
  name: ProviderTypes
  attribution: string
  url: string
}

export interface ProvidersShape {
  [key: string]: ProviderShapeItem
}

export const mapProvidersShape: ProvidersShape = {
  arcgisonline: {
    title: "ArcGIS online",
    name: "arcgisonline",
    attribution: `Tiles © Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community`,
    url: "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
  },
  openstreetmap: {
    title: "OpenStreetMap",
    name: "openstreetmap",
    attribution: `© OpenStreetMap contributors`,
    url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
  },
}
